import styled from "styled-components";

export const Container = styled.div`
  padding: 200px 150px;
  display: flex;
  background-size: cover;
  background-position: center;
  flex-direction: row;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 60px 20px;
    text-align: center;
  }
`;

export const Image = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }

  img {
    max-width: 100%;
    width: 25vw;
    height: auto;

    @media (max-width: 768px) {
      width: 60vw;
    }
  }
`;

export const Text = styled.div`
  width: 55%;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    align-items: center;
  }

  h2 {
    color: var(--white);
    font-size: 62px;
    font-weight: 700;
    margin-bottom: 25px;

    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    text-align: justify;
    color: var(--white);
    margin-bottom: 25px;

    @media (max-width: 768px) {
      font-size: 0.95rem;
    }
  }

  span {
    background-color: var(--gold);
    border: 0;
    color: var(--primary);
    font-size: 14px;
    font-weight: 600;
    padding: 12px 120px;
    line-height: 24px;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }

    @media (max-width: 768px) {
      padding: 12px 40px;
      font-size: 13px;
    }
  }
`;